<script>
  import {getContext} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import {IMAGES} from '../images';
  import JpAppDownButton from './JpAppDownButton.svelte';
  import JpKolMarquee from './JpKolMarquee.svelte';
  import JpBannerVideos from './JpBannerVideos.svelte';
  import lang from '../HomePage.lang';
  import headerLang from '../../header/Header.lang';

  const LG = getContext('LG');

  const appDownloads = [
    {
      img: IMAGES.APP_STORE_HOME,
      url: 'https://apps.apple.com/app/id6444693051',
      type: 'IOS',
    },
    {
      img: IMAGES.GOOGLE_PLAY_HOME,
      url: 'https://play.google.com/store/apps/details?id=com.phemex.pulse',
      type: 'Android',
    },
  ];
</script>

<style>
  .jp-banner {
    margin-top: -64px;
    padding-top: min(144px, 8%);
    background: #fff;
  }
  .container {
    position: relative;
    box-sizing: border-box;
    width: 66%;
    max-width: 1200px;
    text-align: center;
  }
  .arrow {
    position: absolute;
    right: 100%;
    bottom: 90%;
    height: 80px;
  }
  .title {
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 2% 0 0 0;
    width: 100%;
    line-height: 56px;
    font-weight: 700;
    font-size: 56px;
  }
  .pulse-text {
    height: 56px;
  }
  .sub-title {
    padding-top: calc(var(--aspect-ratio) * 36px);
    font-weight: 500;
    font-size: 20px;
    color: #898989;
  }
  .btn-container {
    padding: calc(var(--aspect-ratio) * 68px) 0;
    gap: calc(var(--aspect-ratio) * 32px);
  }
  .arrow.pc {
    display: block;
  }
  .arrow.h5 {
    display: none;
  }
  .launch-app {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(var(--aspect-ratio) * 32px);
    padding: 0 calc(var(--aspect-ratio) * 32px);
    height: calc(var(--aspect-ratio) * 64px);
    font-weight: 700;
    font-size: 18px;
    background: #45e555;
    color: #000;
    cursor: pointer;
  }
  .launch-app:hover {
    color: #000;
  }
  @media screen and (max-width: 640px) {
    .btn-container {
      padding-top: 64px;
    }
    .jp-banner {
      margin-top: 40px;
    }
    .container {
      width: 100%;
    }
    .title {
      padding-top: 24px;
      width: 80%;
      line-height: 28px;
      font-size: 24px;
    }
    .sub-title {
      display: none;
    }
    .pulse-text {
      height: 32px;
    }
    .arrow.pc {
      display: none;
    }
    .arrow.h5 {
      right: 12%;
      bottom: 160%;
      display: block;
      height: 48px;
    }
  }
</style>

<section class="jp-banner df fdc aic pr">
  <div class="container">
    <JpBannerVideos />
    <img class="pulse-text" src={IMAGES.PULSE} />
    <div class="title">
      <img class="arrow pc" src={IMAGES.DOWN_GREEN_ARROW} />
      <img class="arrow h5" src={IMAGES.DOWN_GREEN_ARROW_H5} />
      <span class="text">{LG(lang.JpBannerTitle)}</span>
    </div>
    <div class="sub-title">{LG(lang.JpBannerSubTitle)}</div>
    <div class="btn-container df jcc">
      <a class="launch-app" href={$fixLink$(PATHS.WEB3_SOCIAL_TRADE_EXPLORE_GROUPS.pathname)}> {LG(headerLang.LaunchPulseApp)} </a>
      {#each appDownloads as btn}
        <JpAppDownButton {...btn} />
      {/each}
    </div>
  </div>
  <JpKolMarquee />
</section>
